<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("Private") }} {{ $t("global") }} {{ $t("Options") }}
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div
          :class="
            global.go_id == 1 || global.go_key == 'FRESH_DESK_CONFIG'
              ? 'col-lg-12 col-xl-12 mb-4'
              : 'col-lg-4 mb-4'
          "
          :key="globalListIndex"
          v-for="(global, globalListIndex) in globalList"
        >
          <div
            v-if="
              global.go_id == 3 ||
                global.go_id == 4 ||
                global.go_id == 5 ||
                global.go_id == 6 ||
                global.go_id == 7 ||
                global.go_id == 8 ||
                global.go_id == 9 ||
                global.go_id == 10 ||
                global.go_key == 'DEEPL_API_KEY' ||
                global.go_key == 'MAILCHIMP_API_KEY' ||
                global.go_key == 'FRESH_DESK_KEY' ||
                global.go_key == 'FRESH_DESK_URL' ||
                global.go_key == 'FRESHCHAT_WHATSAPP_FROM_NUMBER' ||
                global.go_key == 'FRESHCHAT_WHATSAPP_NAMESPACE' ||
                global.go_key == 'FRESHCHAT_WHATSAPP_AUTH_TOKEN' ||
                global.go_key == 'CINEPOOL_URL' ||
                global.go_key == 'CINEPOOL_KEY' || 
                global.go_key == 'SENDER_EMAIL' || 
                global.go_key == 'EMAIL_BCC'
            "
          >
            <div class="input-material">
              <input
                v-model="global.go_value"
                v-validate="'required'"
                placeholder="."
                type="text"
                name="subject"
                id="subject"
              />
              <label>{{ global.key_name }}</label>
            </div>
            <p v-if="submitted && errors.has('subject')" class="error_message">
              <span>{{ errors.first("subject") }}</span>
            </p>
          </div>
          <!-- <div
            v-if="
              global.go_id == 1 ||
                global.go_id == 2 ||
                global.go_id == 12 ||
                global.go_id == 19 ||
                global.go_id == 21
            "
          >
            <div class="input-material">
              <input
                type="text"
                placeholder="."
                v-model="global.go_value"
                disabled
              />
              <label>{{ global.key_name }}</label>
            </div>
          </div> -->

          <!-- <div
            v-if="
              global.go_id == 15 ||
                global.go_id == 16 ||
                global.go_id == 17 ||
                global.go_id == 18 ||
                global.go_id == 22 ||
                global.go_id == 23 ||
                global.go_id == 24 ||
                global.go_id == 25 ||
                global.go_key == 'RECCO_ITEM_STOCK_TAKE' ||
                global.go_key == 'POS_CUSTOMER_POPUP'
            "
          >
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="global.go_value"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
              <div class="px-3 small">{{ global.key_name }}</div>
            </div>
          </div> -->

          <div class="row pt-4 border-top" v-if="global.go_id == 1">
              <div class="col-12 pb-3 align-self-center">
                <label class="mb-0 font-weight-semi-bold">{{
                  global.key_name
                }}</label>
              </div>
              <div class="col-4">
                <div class="input-material">
                  <input
                    v-model="authentication.licence_key"
                    v-validate="'required'"
                    placeholder="."
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label>Licence Key</label>
                </div>
              </div>
              <div class="col-4">
                <div class="input-material">
                  <input
                    v-model="authentication.trial_days"
                    v-validate="'required'"
                    placeholder="."
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label>Trial Days</label>
                </div>
              </div>
              <div class="col-4">
                <div class="input-material">
                  <div class="add-datepicker">
                    <Datepicker :monday-first="true"
                      v-model="authentication.expiry_date"
                      ref="expiryDate"
                      name="expiryDate"
                      id="expiryDate"
                      v-validate="'required'"
                      typeable
                    >efwefwf</Datepicker>
                    <label
                    :class="['', authentication.expiry_date ? 'active' : '']"
                      >Expiry Date</label
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-4 border-top" v-if="global.go_key == 'FRESH_DESK_CONFIG'">
              <div class="col-12 pb-3 align-self-center">
                <label class="mb-0 font-weight-semi-bold">{{
                  global.key_name
                }}</label>
              </div>
              <div class="col-4">
                <div class="input-material">
                  <input
                    v-model="freshDeskCofig.email_config_id"
                    v-validate="'required'"
                    placeholder="."
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label>Email Config Id</label>
                </div>
              </div>
              <div class="col-4">
                <div class="input-material">
                  <input
                    v-model="freshDeskCofig.cc_emails"
                    v-validate="'required'"
                    placeholder="."
                    type="text"
                    name="subject"
                    id="subject"
                  />
                  <label>CC Emails (comma seprated)</label>
                </div>
              </div>
            </div>

          <!-- <div
            v-if="
              global.go_id == 7 ||
                global.go_id == 8 ||
                global.go_id == 9 ||
                global.go_id == 10 ||
                global.go_id == 11 ||
                global.go_id == 31 ||
                global.go_id == 30
            "
          >
            <div v-if="global.go_id == 8">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="app_language"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(language, languageIndex) in ActiveLanguages"
                    :key="languageIndex"
                    v-on:click="OnSelect('lang', language, globalListIndex)"
                    >{{ language.lang_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div v-if="global.go_id == 9">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="operation_country"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(country, countryIndex) in ActiveCountries"
                    :key="countryIndex"
                    v-on:click="OnSelect('country', country, globalListIndex)"
                    >{{ country.country_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div v-if="global.go_id == 10">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="currency_name"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(currency, currencyIndex) in ActiveCurrencies"
                    :key="currencyIndex"
                    v-on:click="OnSelect('currency', currency, globalListIndex)"
                    >{{ currency.curr_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div v-if="global.go_id == 11">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="concession_name"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(concession, concessionIndex) in ActiveConcessions"
                    :key="concessionIndex"
                    v-on:click="
                      OnSelect('concession', concession, globalListIndex)
                    "
                    >{{ concession.cl_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div class="row pt-4 border-top" v-if="global.go_id == 7">
              <div class="col-12 pb-3 align-self-center">
                <label class="mb-0 font-weight-semi-bold">{{
                  global.key_name
                }}</label>
              </div>
              <div class="col-3">
                <div class="dropdown-curve-container">
                  <label class="shift-up">Select Country</label>
                  <b-dropdown
                    variant="dropdown-curve"
                    class="w-100"
                    :text="content_country.country_name"
                  >
                    <b-dropdown-item
                      href="#"
                      v-for="(country, countryIndex) in ActiveCountries"
                      :key="countryIndex"
                      v-on:click="OnSelect('country', country, globalListIndex)"
                      >{{ country.country_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
              <div class="col-9" v-if="global.go_id == 7">
                <multiselect
                  :options="ActiveLanguages"
                  v-model="content_language"
                  :searchable="true"
                  label="lang_name"
                  track-by="lang_id"
                  placeholder="Select Language"
                  :allowEmpty="false"
                  :showLabels="false"
                  :multiple="true"
                ></multiselect>
              </div>
            </div>

            <div class="row" v-if="global.go_id == 30">
              <span class="small-text ml-4">Kiosk Languages</span>
              <div class="col-12">
                <multiselect
                  :options="ActiveLanguages"
                  v-model="selectedLanguages"
                  :searchable="true"
                  label="lang_name"
                  track-by="lang_id"
                  placeholder="Select Languages"
                  :allowEmpty="false"
                  :showLabels="false"
                  :multiple="true"
                />
              </div>
            </div> -->

            <!-- <div class="row pt-4 border-top" v-if="global.go_id == 31">
              <div class="col-6">
                <multiselect
                  :options="Cinemas"
                  v-model="selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  :allowEmpty="false"
                  :showLabels="false"
                  @select="onSelectCinema($event)"
                />
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4 text-center">
        <button
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit()"
          class="btn-blue"
        >
          {{ $t("update") }}</button
        >&nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      globalList: [],
      submitted: false,
      ActiveCountries: [],
      selectedCountry: "",
      operation_country: "",
      ActiveLanguages: [],
      content_language: [],
      content_country: {},
      app_language: "",
      ActiveCurrencies: [],
      currency_name: "",
      ActiveConcessions: [],
      Cinemas: [],
      concession_name: "",
      globalListCopy: [],
      selectedCinema: null,
      selectedLanguages: null,
      authentication: {
        licence_key: "",
        expiry_date: "",
        trial_days: 0
      },
      freshDeskCofig: {
        email_config_id: "",
        cc_emails: [],
      }
    };
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;

    if (roleid != 1) {
      this.$router.go(-1);
    } else {
      this.getGlobalOptions();
    }
  },
  methods: {
    onSelectCinema(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.$forceUpdate();
    },
    getGlobalOptions: function() {
      let loader = this.$loading.show();

      MasterService.GetPrivateGlobalOptions()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.globalList = data.Records.filter(x => {
            //   return (
            //     x.go_id != 2 && x.go_id != 12 && x.go_id != 14 && x.go_id != 19
            //   );
            // });
            this.globalList = data.Records;
            // const arr_copy = [...data.Records]
            this.globalListCopy = JSON.parse(JSON.stringify(this.globalList));
            this.globalList.map(x => {
              if(x.go_key === "AUTHENTICATION_KEY") {
                let obj = [];
                try {
                  obj = JSON.parse(x.go_value);
                } catch(err) {
                  console.log(err);
                }
                console.log("authentication object", obj)
                this.authentication.licence_key = obj[0] ? obj[0].license_key : "";
                this.authentication.expiry_date = (obj[0] && Date.parse(new Date(obj[0].expiry_date))) ? new Date(obj[0].expiry_date) : new Date();
                this.authentication.trial_days = obj[0] ? parseInt(obj[0].trial_days) : 0;
              }
              if(x.go_key === "FRESH_DESK_CONFIG") {
                let ConfigObj = [];
                try {
                  ConfigObj = JSON.parse(x.go_value);
                } catch(err) {
                  console.log(err);
                }
                console.log("authentication object", ConfigObj)
                this.freshDeskCofig.email_config_id = ConfigObj ? ConfigObj.email_config_id : "";
                this.freshDeskCofig.cc_emails = ConfigObj ? ConfigObj.cc_emails.join(', ') : "";
                console.log("this.freshDeskCofig.email_config_id", this.freshDeskCofig.email_config_id)
                console.log("this.freshDeskCofig.cc_emails", this.freshDeskCofig.cc_emails)
              }
              // if (x.go_id == 9) {
              //   this.getActiveCountries(x.go_value, 2);
              // }
              // if (x.go_id == 7) {
              //   let obj = JSON.parse(x.go_value);
              //   console.log("obj :>> ", obj);
              //   this.getActiveCountries(obj[0].country_id, 1);
              //   this.getActiveLanguages(obj[0].lang_id, 1);
              // }
              // if (x.go_id == 8) {
              //   this.getActiveLanguages(x.go_value, 2);
              // }
              // if (x.go_id == 10) {
              //   this.getActiveCurrencies(x.go_value);
              // }
              // if (x.go_id == 11) {
              //   this.getActiveConcessions(x.go_value);
              // }
              // if (x.go_id == 31) {
              //   this.getCinemaList();
              //   this.selectedCinema = JSON.parse(x.go_value);
              // }
              // if (x.go_id == 30) {
              //   this.selectedLanguages = JSON.parse(x.go_value);
              // }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    // async getCinemaList(cine_id) {
    //   try {
    //     const { data } = await MasterService.GetCinemas({ cine_id });
    //     if (data && data.status && data.Records.length > 0) {
    //       this.Cinemas = data.Records;
    //       this.Cinemas.map(x => {
    //         if (String(cine_id) === String(x.cine_id)) {
    //           // this.selectedCinema = x.cine_name;
    //           this.onSelectCinema(null, {
    //             cine_name: x.cine_name,
    //             cine_id: x.cine_id
    //           });
    //         }
    //       });
    //     } else {
    //       this.$toasted.show(
    //         data.message ||
    //           "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     }
    //   } catch (error) {
    //     this._CatchError;
    //   }
    // },
    getActiveCurrencies(curr_id) {
      let body = {
        tableName: "ms_currencies",
        curr_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveCurrencies = data.Records;
              this.ActiveCurrencies.map(x => {
                if (String(curr_id) === String(x.curr_id)) {
                  this.currency_name = x.curr_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveConcessions(cl_id) {
      let body = {
        tableName: "ms_concession_levels",
        cl_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveConcessions = data.Records;
              this.ActiveConcessions.map(x => {
                if (String(cl_id) === String(x.cl_id)) {
                  this.concession_name = x.cl_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveCountries(country_id, flag) {
      let body = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveCountries = data.Records;
              console.log("this.ActiveCountries :>> ", this.ActiveCountries);
              this.ActiveCountries.map(x => {
                if (String(country_id) === String(x.country_id) && flag == 2) {
                  this.operation_country = x.country_name;
                } else if (
                  String(country_id) === String(x.country_id) &&
                  flag == 1
                ) {
                  this.content_country = x;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveLanguages(lang_id, flag) {
      let body = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveLanguages = data.Records;
              console.log("this.ActiveLanguages :>> ", this.ActiveLanguages);
              this.ActiveLanguages.map(x => {
                if (flag == 1) {
                  lang_id.map(y => {
                    if (String(y) === String(x.lang_id)) {
                      this.content_language.push(x);
                    }
                  });
                } else if (String(lang_id) === String(x.lang_id) && flag == 2) {
                  this.app_language = x.lang_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function() {
      let finalObj = [];
      // let arr = [
      //   {
      //     country_id: this.content_country.country_id,
      //     lang_id: this.content_language.map(x => {
      //       return x.lang_id;
      //     })
      //   }
      // ];
      // let arr2 = JSON.stringify(arr);
      // console.log("arr2 :>> ", arr2);
      this.globalList.map(x => {
        // if (x.go_id == 7) {
        //   x.go_value = arr2;
        // }
        // if (x.go_id == 31) {
        //   x.go_value = JSON.stringify(this.selectedCinema);
        // }
        // if (x.go_id == 30) {
        //   x.go_value = JSON.stringify(this.selectedLanguages);
        // }

        // [{"license_key":"5eb272880e8fb21935bb99f3","trial_days":"15","expiry_date":1588839432360}]
        if (x.go_id == 1) {
          x.go_value = JSON.stringify([{
            license_key: this.authentication.licence_key,
            trial_days: parseInt(this.authentication.trial_days),
            expiry_date: this.authentication.expiry_date.getTime()
          }]);
        }
        //Latest Comment
        // if(x.go_key == 'FRESH_DESK_CONFIG') {
        //   x.go_value = JSON.stringify({
        //     email_config_id: this.freshDeskCofig.email_config_id,
        //     cc_emails: this.freshDeskCofig.cc_emails.split(',').map(item => item.trim()),
        //   })
        // }
      });
      console.log("this.globalList :>> ", this.globalList);
      this.globalList.map((x, i) => {
        // console.log('x.go_value :>> ', x.go_value);
        // console.log('this.globalListCopy[i].go_value :>> ',this.globalListCopy[i].go_value);
        if (x.go_value != this.globalListCopy[i].go_value) {
          finalObj.push(x);
        }
      });
      console.log("finalObj :>> ", finalObj);

      let payload = {
        globalList: finalObj
      };
      MasterService.EditPrivateGlobalOptions(payload)
        .then(response => {
          const { data } = response;
          // loader.hide();
          if (data && data.status) {
            this.$toasted.show(data.message);

            this.$router.push({
              path: "/home"
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    OnSelect(type, item, index) {
      if (type == "country" && this.globalList[index].go_id == 9) {
        this.operation_country = item.country_name;
        this.globalList[index].go_value = item.country_id;
        console.log(
          "this.globalList[index].go_value :>> ",
          this.globalList[index].go_value
        );
      } else if (type == "country" && this.globalList[index].go_id == 7) {
        this.content_country = item;
      } else if (type == "lang") {
        this.app_language = item.lang_name;
        this.globalList[index].go_value = item.lang_id;
      } else if (type == "concession") {
        this.concession_name = item.cl_name;
        this.globalList[index].go_value = item.cl_id;
        console.log("concession :>> ", this.globalList[index].go_value);
      } else if (type == "currency") {
        this.currency_name = item.curr_name;
        this.globalList[index].go_value = item.curr_id;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GlobalOptionsComponents/globalOptionsPrivate.vue